/* eslint-disable import/no-default-export */

class ObjectGet {
    constructor(obj) {
        this._value = obj;
    }

    at(key) {
        return new ObjectGet(this.value(key));
    }

    maybe(fun) {
        if (this._value) {
            return fun(this._value);
        }
        return null;
    }

    value(key) {
        const v = this._value;
        return v && v[key];
    }
}

function getter(obj) {
    if (typeof obj === 'object' && !Array.isArray(obj)) {
        return new ObjectGet(obj);
    }
    return new ObjectGet(null);
}

export default getter;
